import { IModalServiceInstance } from "angular-ui-bootstrap";
import { NotifyService } from "infrastructure/services/notifyService";
import "ugsk-osago-cancel-modal.css";
import { AsyncContractSaleService } from "infrastructure/services/async.contract.sale.service";
import { CONTRACT_STATUSES } from "application/constants";

export class CancelModal {
    public reasonCode: string = "";
    public UserCancelReasonDocument = null;

    static get $inject() {
        return ["$uibModalInstance", "notifyService", "asyncContractSaleService", "context", "$scope"];
    }

    constructor(
        private $uibModalInstance: IModalServiceInstance,
        private notifyService: NotifyService,
        private asyncContractSaleService: AsyncContractSaleService,
        private context: any,
        private $scope,
    ) {
        'ngInject';
    }

    public $onInit() {}

    public cancelReasonDocumentSelected(files) {
        this.UserCancelReasonDocument = files ? files[0] : null;
    }

    public ok() {
        this.notifyService.progressStart("Подождите, пожалуйста...");
        const formData = new FormData();
        formData.append("UserCancelReasonDocument", this.UserCancelReasonDocument);
        formData.append("reasonCode", this.reasonCode);
        this.asyncContractSaleService.cancelOsago(this.context.Contract.Id, formData).on("onResult", (result) => {
            if (result.status === 200) {
                this.notifyService.progressStop();
                this.$uibModalInstance.close({ result });
                if (result.response.Header.Complete && result.response.Header.ProcessingResultCode === 0) {
                    this.notifyService.successMessage(undefined, "Операция выполнена успешно.");
                    if (this.context.getViewType() !== "journal") {
                        this.context.pageSharedData.Form.$setPristine();
                        this.context.$state.go(this.context.$state.current.name, { id: this.context.Contract.Id, update: Date.now() }, { inherit: false, reload: true });
                    } else {
                        this.context.Contract.StatusCode = CONTRACT_STATUSES.CANCELED;
                        this.context.Contract.StatusId = CONTRACT_STATUSES.CANCELED;
                        this.context.Contract.StatusName = "Отменен";
                    }
                }
            } else if (result.status !== 500) {
                this.notifyService.progressStop();
                this.notifyService.errorMessage("Ошибка", result.message);
            }
        });
    }

    public close() {
        this.$uibModalInstance.close();
    }
}